'use strict';
import angular from 'angular';
import './scripts/ioServiceConnections.ctrls';
import './scripts/ioServiceConnections.services';

import serviceConnectionsHtmlUrl from './views/serviceConnections.html';

angular.module('ioServiceConnections', ['ioServiceConnections.ctrls', 'ioServiceConnections.services'])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('ioServiceConnections', {
                parent: 'layout',
                url: '/admin/ioServiceConnections',
                templateUrl: serviceConnectionsHtmlUrl,
                controller: 'ioServiceConnectionsController'
            })
            .state('ioServiceConnectionsWithServiceId', {
                parent: 'layout',
                url: '/admin/ioServiceConnections/:serviceId',
                templateUrl: serviceConnectionsHtmlUrl,
                controller: 'ioServiceConnectionsController'
            })
    }]);